import LoadingSpinner from "@/app/components/atoms/LoadingSpinner";

/**
 * @component RegisterConfirmingStep
 * @description Full-screen loading state shown while the account is being
 * created. Announced to assistive technology via `aria-live` + `aria-busy`.
 * @returns A centered spinner with a status message.
 */
export default function RegisterConfirmingStep() {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 py-16"
      aria-live="polite"
      aria-busy="true"
    >
      <LoadingSpinner />
      <p className="text-body-base text-muted-text">Creating your account…</p>
    </div>
  );
}
